export const translations = {
    en: {
        knowBeforeYouGo: "Know before you go!",
        whereMeetUs: "Where shall you meet us?",
        clientReference: "Client Reference",
        name: "Name",
        surname: "Surname",
        email: "Email",
        countryCode: "Country code",
        phone: "Phone",
        startingTime: "Starting Time",
        date: "Date",
        language: "Language",
        summery: "Summery",
        price: "Price",
        experienceCurrency: "Experience currency",
        howMuchCancel: "How much will it cost to cancel?",
        cancelPolicy: "*After booking, the full amount (100%) will not be refunded.",
        book: "Book",
        bookNow: "Book now",
        totalPrice: "Total Price",
        discount: "Discount",
        guestCount: "Guest Count",
        child: "Child",
        adults: "Adults",
        children: "Children",
        selectLanguage: "Select Language",
        inclusions: "Inclusions",
        armenian: "Armenian",
        english: "English",
        german: "German",
        spanish: "Spanish",
        french: "French",
        italy: "Italian",
        portugal: "Portuguese",
        bookingError: "Failed to submit booking. Please try again.",
        callbackError: "Failed to submit request. Please try again.",
        bookingSuccess: "Your booking has been submitted successfully!",
        bookingSuccessMessage: "We are pleased to inform you that your booking has been successfully made.",
        loading: "Loading...",
        bookingInProgress: "Booking...",
        sending: "Sending...",
        send: "Send",
        message: "Message",
        willYouShare: "Will you share with us?",
        numberOfGuests: "Number of guests",
        total: "Total",
        region: "Region",
        city: "City",
        country: "Country",
        tourDuration: "Tour Duration",
        meetingPoint: "Meeting point",
        day: "day",
        hour: "hour",
        minute: "minute",
        pleaseFillRequired: "Please fill in all required fields",
        maxParticipants: "The maximum number of participants is",
        minParticipants: "At least",
        minParticipantsSuffix: "participants are required for this experience.",
        pleaseChooseLanguage: "Please choose language!",
        pleaseChooseStartingTime: "Please choose starting time!",
        pleaseChooseDate: "Please choose date!",
    },
    de: {
        knowBeforeYouGo: "Wissenswertes vor Ihrer Reise!",
        whereMeetUs: "Wo treffen wir uns?",
        clientReference: "Kundenreferenz",
        name: "Vorname",
        surname: "Nachname",
        email: "E-Mail",
        countryCode: "Ländervorwahl",
        phone: "Telefon",
        startingTime: "Startzeit",
        date: "Datum",
        language: "Sprache",
        summery: "Zusammenfassung",
        price: "Preis",
        experienceCurrency: "Erlebniswährung",
        howMuchCancel: "Wie viel kostet eine Stornierung?",
        cancelPolicy: "*Nach der Buchung wird der volle Betrag (100 %) nicht zurückerstattet.",
        book: "Buchen",
        bookNow: "Jetzt buchen",
        totalPrice: "Gesamtpreis",
        discount: "Rabatt",
        guestCount: "Anzahl der Gäste",
        child: "Kind",
        adults: "Erwachsene",
        children: "Kinder",
        selectLanguage: "Sprache auswählen",
        inclusions: "Leistungen inklusive",
        armenian: "Armenisch",
        english: "Englisch",
        german: "Deutsch",
        spanish: "Spanisch",
        french: "Französisch",
        italy: "Italienisch",
        portugal: "Portugiesisch",
        bookingError: "Buchung konnte nicht übermittelt werden. Bitte versuchen Sie es erneut.",
        callbackError: "Anfrage konnte nicht übermittelt werden. Bitte versuchen Sie es erneut.",
        bookingSuccess: "Ihre Buchung wurde erfolgreich übermittelt!",
        bookingSuccessMessage: "Wir freuen uns, Ihnen mitteilen zu können, dass Ihre Buchung erfolgreich abgeschlossen wurde.",
        loading: "Laden...",
        bookingInProgress: "Buchung läuft...",
        sending: "Wird gesendet...",
        send: "Senden",
        message: "Nachricht",
        willYouShare: "Möchten Sie uns etwas mitteilen?",
        numberOfGuests: "Anzahl der Gäste",
        total: "Gesamt",
        region: "Region",
        city: "Stadt",
        country: "Land",
        tourDuration: "Tourdauer",
        meetingPoint: "Treffpunkt",
        day: "Tag",
        hour: "Stunde",
        minute: "Minute",
        pleaseFillRequired: "Bitte füllen Sie alle Pflichtfelder aus",
        maxParticipants: "Die maximale Teilnehmerzahl beträgt",
        minParticipants: "Mindestens",
        minParticipantsSuffix: "Teilnehmer sind für dieses Erlebnis erforderlich.",
        pleaseChooseLanguage: "Bitte wählen Sie eine Sprache!",
        pleaseChooseStartingTime: "Bitte wählen Sie eine Startzeit!",
        pleaseChooseDate: "Bitte wählen Sie ein Datum!",
    }
};

export const getTranslation = (lang, key) => {
    return translations[lang]?.[key] || translations['en']?.[key] || key;
};
